<!-- <mat-grid-list class="risk-metric-bar" *ngIf="tiles.length > 0" gutterSize="3" [cols]="columnCount()" rowHeight="fit">
    <mat-grid-tile fxLayout="col" fxLayoutGap="0" fxLayoutAlign="center center" class="risk-metric-box" [colspan]="tile.cols"
        [rowspan]="tile.rows" *ngFor="let tile of tiles; trackBy: trackTile">
        <app-dashboard-metric  class="risk-metric" fxFlex="auto" fxLayoutGap="0" [riskMetric]="tile.metric"></app-dashboard-metric>
    </mat-grid-tile>
</mat-grid-list> -->
<!-- [fxHide]="!tile.metric.selected && !isNoneSelected()" -->
<!-- <p-progressSpinner *ngIf="!initialized" class="spinner" [style]="{width: '50px', height: '50px'}" animationDuration="2s"></p-progressSpinner> -->
<div *ngIf="!initialized"  class="splash-screen">
    <!--<div class="splash-loader"></div>-->
    <img class="splash-logo" align="center" height="40px" src="assets/liquitics-logo.svg" />
    <p-progressBar [value]="progress"></p-progressBar>
</div>

<div fxLayout="row wrap" *ngIf="labelTiles && labelTiles.length > 0" class="risk-metric-bar ">
    <ng-container *ngFor="let labelTile of labelTiles">
        <app-dashboard-metric *ngIf="labelTile.metric.type ==='Single' && labelTile.metric.label === 'Type'" class="risk-metric liquitics-box" fxFlex="1 1 calc(22%-10px)" fxFlex.lt-sm="2 1 calc(50%-10px)"
            [dashboardMetricSet]="labelTile.metric" [index]="0"></app-dashboard-metric>
        <app-dashboard-metric *ngIf="labelTile.metric.type ==='Single' && labelTile.metric.label !== 'Type'" class="risk-metric liquitics-box" fxFlex="6 1 calc(13%-10px)" fxFlex.lt-sm="2 1 calc(50%-10px)"
            [dashboardMetricSet]="labelTile.metric" [index]="0"></app-dashboard-metric>
    </ng-container>
</div>

<div fxLayout="row wrap" *ngIf="dashboardMetricSets && dashboardMetricSets.length > 0" class="risk-metric-bar ">
    <ng-container *ngFor="let tile of tiles">
        <app-dashboard-metric *ngIf="tile.metric.type ==='Top3'" class="risk-metric liquitics-box" fxFlex="2 1 calc(50%-10px)" fxFlex.lt-sm="2 1 100%"
            [dashboardMetricSet]="tile.metric" [index]="tile.metric.categoryIndex + 1"></app-dashboard-metric>
        <app-dashboard-metric *ngIf="tile.metric.type ==='Single'" class="risk-metric liquitics-box" [fxFlex]="tile.fxFlex" fxFlex.lt-sm="2 1 calc(50%-10px)"
            [dashboardMetricSet]="tile.metric" [index]="tile.metric.categoryIndex + 1" ></app-dashboard-metric>
        <app-dashboard-metric *ngIf="tile.metric.type ==='Placeholder'" class="risk-metric liquitics-box" fxFlex="4 1 calc(25%-10px)" fxFlex.lt-sm="2 1 calc(50%-10px)"
            [dashboardMetricSet]="tile.metric" [index]="tile.metric.categoryIndex + 1"></app-dashboard-metric>
    </ng-container>
    <ng-container *ngFor="let blank of blankTiles">
        <div class="risk-metric liquitics-box" fxFlex="4 1 calc(25%-10px)" fxFlex.lt-sm="2 1 calc(50%-10px)"></div>
    </ng-container>
</div>
